/* Utils */
import { createDeferredPromise, isSessionExpired } from './utils';

/**
 * @returns {import('../createService').RenewCredentialsCreator}
 */
export default function createRenewCredentialsOnlySessionToken(onFailed) {
  let deferredRenew;

  return (backendService) => async (currentCredentials, shouldRenew) => {
    if (deferredRenew) {
      const {
        promise,
        data: {
          sessionToken: renewingSessionToken,
        },
      } = deferredRenew;
      if ((shouldRenew.sessionToken && renewingSessionToken) || !shouldRenew.sessionToken) {
        return promise;
      }
    }

    deferredRenew = createDeferredPromise(shouldRenew);
    try {
      let newCredentials = currentCredentials;
      const {
        sessionTokenData,
        sessionTokenData: { sessionToken: currentSessionToken },
      } = currentCredentials;

      if (
        currentSessionToken
          && shouldRenew.sessionToken
          && isSessionExpired(currentSessionToken)
      ) {
        const response = await backendService.subscriber.renewToken();
        const { data: { sessionToken } = {} } = response;

        newCredentials = {
          ...currentCredentials,
          sessionTokenData: {
            ...sessionTokenData,
            sessionToken,
          },
        };
      }

      deferredRenew.resolve(newCredentials);
      deferredRenew = undefined;

      return newCredentials;
    } catch (error) {
      console.error('renewCredentialsOnlySessionToken error:', error);
      deferredRenew.reject(error);
      deferredRenew = undefined;
      onFailed(error);
      throw error;
    }
  };
}
